/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RenewalKind {
  NONE = 'NONE',
  YEARLY = 'YEARLY',
  QLE = 'QLE',
  ICHRA_TO_ICHRA = 'ICHRA_TO_ICHRA',
}
